import ManagementHero from './components/ManagementHero';
import OrgStructure from './components/OrgStructure';
import ExecutiveTeam from './components/ExecutiveTeam';
import ManagementTeam from './components/ManagementTeam';

export default function ExpertsPage() {
  return (
    <main>
      <ManagementHero />
      <OrgStructure />
      <ExecutiveTeam />
      <ManagementTeam />
    </main>
  );
}